import gql from "graphql-tag";

const PAGES_QUERY = gql`  
  query Pages {
    pages {
        id
        slug
        title
        body
        parent { 
            id
            slug
        }
        children {
          id
          slug
        }
        updatedAt
        createdAt
        published
    }
  }
`;

export default PAGES_QUERY;